import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import {ClanAuthority, ClanPosition} from "@/store/clan/types";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import ClanUtils from "@/utils/clan-utils";

export class ClanActionsPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, level: number, clanPostion: ClanPosition, authorities: ClanAuthority[], resignCallback: () => unknown, leaveCallback: () => unknown,
                diffCallback: () => unknown, themeCallback: () => unknown, historyCallback: () => unknown) {
        super(scene, canvas, Tr('deystvija'));

        let blockFirst = TextUtils.addTextAdvanced(scene, Tr('emissar.privetstvuju') + ClanUtils.getPositionName(clanPostion) + '. ' + Tr('at.y.service') + '.', 0, -135,
            '#a2ff82', 14, 'normal', 400, 'center', 2, Fonts.ARIAL_MT);

        this.add([blockFirst]);

        let difficultyChangeVisible = authorities.includes(ClanAuthority.CHANGE_RAID_DIFFICULTY) && level >= 10;

        let hopeForInviteText = TextUtils.addTextByFamily(scene, Tr('viberite.deystvie.'), 0, -40,
            '#ffd465', 18, 'bold', 300, Fonts.MYRIADPRO_REGULAR)
            .setVisible(!difficultyChangeVisible);

        this.add(hopeForInviteText);

        let btn1 = this.addCustomButton(-135, -30,Tr('slozhnost.zadanija'), Keys.UI_ART_BROWN_BUTTON, undefined, Keys.CLAN_GEAR_2, diffCallback)
            .setVisible(difficultyChangeVisible);

        let btn2 = this.addCustomButton(0, -30, Tr('cln.top'), Keys.UI_ART_BROWN_BUTTON, undefined, Keys.CLAN_GEAR_3, themeCallback)
            .setVisible(difficultyChangeVisible);

        let btn3 = this.addCustomButton(135, -30,Tr('clan.history'), Keys.UI_ART_BROWN_BUTTON, undefined, Keys.CLAN_GEAR_4, historyCallback)
            .setVisible(difficultyChangeVisible);

        btn1.setScale(0.9)
        btn2.setScale(0.9)
        btn3.setScale(0.9)

        let btn4 = this.addCustomButton(-100, 150,Tr('zakrit'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => {});

        let btn5!:Phaser.GameObjects.Container;
        if (clanPostion === ClanPosition.LEADER) {
            btn5 = this.addCustomButton(100, 150, Tr('uyti.v.otstavku'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_DECLINE_CROSS, resignCallback);
        } else {
            btn5 = this.addCustomButton(100, 150, Tr('pokinut.klan'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_DECLINE_CROSS, leaveCallback);
        }
    }

}
